import React from "react";
import PropTypes from "prop-types";

// Components
import { Input } from "antd";
import { CheckOutlined } from "@ant-design/icons";

const InputWithVerification = ({ value, setValue, isVerified, label, labelText, disabled, prefix }) => (
  <div className="user-create-input">
    <div className="form-label">{label ? label : labelText}</div>
    <div className="input-with-verification">
      <div className="input-wrap">
        {prefix}
        <Input disabled={disabled} onChange={(e) => setValue(e.target.value)} value={value} placeholder={labelText} />
        <div className="check-wrap">{isVerified ? <CheckOutlined /> : null}</div>
      </div>
    </div>
  </div>
);

InputWithVerification.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  isVerified: PropTypes.bool.isRequired,
  label: PropTypes.element,
  labelText: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  prefix: PropTypes.element,
};

export default InputWithVerification;
